import { render, staticRenderFns } from "./ProjectMedia.vue?vue&type=template&id=c7fac8ca&scoped=true"
import script from "./ProjectMedia.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectMedia.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7fac8ca",
  null
  
)

export default component.exports